import { render, staticRenderFns } from "./mocReviewEmergency.vue?vue&type=template&id=0001d985"
import script from "./mocReviewEmergency.vue?vue&type=script&lang=js"
export * from "./mocReviewEmergency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0001d985')) {
      api.createRecord('0001d985', component.options)
    } else {
      api.reload('0001d985', component.options)
    }
    module.hot.accept("./mocReviewEmergency.vue?vue&type=template&id=0001d985", function () {
      api.rerender('0001d985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocReviewEmergency.vue"
export default component.exports